{
  "title": "MPPNext Web Site",
  "account": "Account",
  "secret": "Password",
  "login": "Login",
  "loginError": "Invalid input",
  "badCaptcha": "Incorrect verification code",
  "lockoutPrompt": "Your account has been temporarily locked after {maxLoginAttempts} failed login attempts. Please try again in {lockoutDuration} minutes.",
  "version": "Version: v{v}"
}